export enum Action {
  Suspend = 'suspend',
  Unsuspend = 'unsuspend',
  Delete = 'delete',
  Edit = 'edit',
}
